import { useSettings } from '@wu/widget-core';
import type { StripeIntegrationSettings } from '../../common';

export function useIsStripeConnected() {
  const {
    integrationStripe: {
      id: stripeIntegrationId,
      publishableKey: stripePublicKey
    }
  } = useSettings<StripeIntegrationSettings>();

  return !!(stripeIntegrationId && stripePublicKey);
}
